import { IonCol, IonGrid, IonList, IonRow } from '@ionic/react';

import styles from '@/components/CreateSessionModalContent/ModalContent.module.css';
import { Input } from '@/components/Input';
import { CustomLoading } from '@/components/Loading';

import { mergeClassNames } from '@/utils';

type CreateSessionModalContentProps = {
  sessionData?: {
    date: string;
  };
  onInputChange: (field: string, value: string) => void;
  loading: boolean;
};

export const CreateSessionModalContent = ({ sessionData, onInputChange, loading }: CreateSessionModalContentProps) => {
  if (!sessionData) {
    return null;
  }

  return (
    <>
      <div className={styles.container}>
        {/* 🔥 Overlay that covers the form when loading */}
        {loading && (
          <div className={styles.loadingOverlay}>
            <CustomLoading message='Creating Session...' size='large' />
          </div>
        )}
        <IonGrid className={styles.wrapper}>
          <IonRow
            className='ion-align-items-center ion-justify-content-center ion-padding-vertical'
            style={{ width: '100%' }}>
            <IonCol className='ion-margin-top' size='12'>
              <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
                <Input
                  disabled={loading}
                  label='Select the date of the session'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('date', e.detail.value!)}
                  placeholder={sessionData.date}
                  type='date'
                  value={sessionData.date}
                  variant='light'
                />
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
    </>
  );
};
